/**
 * 菜单管理（只读）— 数据来自种子；GET /api/admin/menus
 */
import { useQuery } from '@tanstack/react-query';
import { Table, Tag } from 'antd';
import { api } from '../../api/client';

interface MenuRow {
  id: number;
  category: string;
  name: string;
  route: string | null;
  sort: number;
}

export function MenusPage() {
  const { data = [], isFetching } = useQuery({
    queryKey: ['admin', 'menus'],
    queryFn: () => api.get<MenuRow[]>('/api/admin/menus'),
  });

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 70 },
    { title: '分类', dataIndex: 'category', width: 100 },
    { title: '名称', dataIndex: 'name' },
    { title: '路由键', dataIndex: 'route', render: (v: string | null) => v ?? '—' },
    { title: '排序', dataIndex: 'sort', width: 80 },
  ];

  return (
    <Table<MenuRow>
      size="small"
      bordered
      rowKey="id"
      loading={isFetching}
      dataSource={data}
      columns={columns}
      pagination={false}
      title={() => (
        <span>
          侧栏菜单由数据库种子维护，与{' '}
          <Tag>packages/admin/src/config/admin-menu-tree.tsx</Tag> 对齐；此处仅查看。
        </span>
      )}
    />
  );
}
